import React, { useState } from 'react';
import { Navbar, Nav, NavDropdown, Container } from 'react-bootstrap';
import { useLanguage } from './LanguageContext';
import { Link, useLocation, useNavigate } from 'react-router-dom'; // Import useLocation & useNavigate

const NavbarComponent = () => {
    const { translations, setLanguage } = useLanguage();
    const [expanded, setExpanded] = useState(false); // Control navbar collapse state
    const location = useLocation();
    const navigate = useNavigate();

    const handleLanguageChange = (lang) => {
        setLanguage(lang);
    };

    const scrollToSection = (id) => {
        if (location.pathname !== "/") {
            // Navigate to home and then scroll
            navigate("/", { replace: true });
            setTimeout(() => {
                const element = document.getElementById(id);
                if (element) {
                    element.scrollIntoView({ behavior: 'smooth' });
                }
            }, 100); // Delay scrolling to ensure navigation has happened
        } else {
            // Directly scroll if already on home
            const element = document.getElementById(id);
            if (element) {
                element.scrollIntoView({ behavior: 'smooth' });
            }
        }
        setExpanded(false); // Collapse navbar after clicking
    };

    return (
        <Navbar
            bg="dark"
            variant="dark"
            expand="lg"
            fixed="top"
            expanded={expanded}
            className="shadow-sm"
        >
            <Container>
                <Navbar.Toggle
                    aria-controls="navbar-nav"
                    onClick={() => setExpanded(!expanded)}
                />
                <Nav>
                    <Nav.Link onClick={() => scrollToSection('about')}>
                        <img src="/images/PDBF_final-02.png" alt="Logo" width={30} height={30} />
                    </Nav.Link>
                </Nav>
                <Navbar.Collapse id="navbar-nav">
                    <Nav className="me-auto">
                        <Nav.Link onClick={() => scrollToSection('about')}>{translations.navbar.about}</Nav.Link>
                        <Nav.Link onClick={() => scrollToSection('service')}>{translations.navbar.service}</Nav.Link>
                        <Nav.Link onClick={() => scrollToSection('equipment')}>{translations.navbar.equipment}</Nav.Link>
                        <Nav.Link onClick={() => scrollToSection('contact')}>{translations.navbar.contact}</Nav.Link>
                        <Nav.Link onClick={() => scrollToSection('reference')}>{translations.navbar.reference}</Nav.Link>

                        {/* New Label Entry */}
                        <Nav.Link as={Link} to="/label">{translations.navbar.label}</Nav.Link>
                    </Nav>
                    <Nav>
                        <NavDropdown title={translations.navbar.select_language} id="language-dropdown" align="end">
                            <NavDropdown.Item onClick={() => handleLanguageChange('en')}>English</NavDropdown.Item>
                            <NavDropdown.Item onClick={() => handleLanguageChange('de')}>Deutsch</NavDropdown.Item>
                        </NavDropdown>
                    </Nav>
                </Navbar.Collapse>
            </Container>
        </Navbar>
    );
};

export default NavbarComponent;